module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full"
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "name": _vm.transition,
      "duration": {
        enter: 150,
        leave: 50
      }
    },
    on: {
      "after-leave": _vm.debounce
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": "dashboard"
    }
  }, [_c('router-view', {
    key: _vm.$store.state.user.affiliate_id,
    attrs: {
      "affiliate": _vm.$store.state.user.affiliate_id
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43dc9638","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/index.vue
// module id = wuCQ
// module chunks = 1